import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-welcome-modal',
  templateUrl: './welcome-modal.component.html',
  styleUrls: ['./welcome-modal.component.css']
})
export class WelcomeModalComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  goToCotizacion() {
    this.router.navigateByUrl('/cotizacion/123');
  }

}
